// frontend/src/config/memberValidation.js

const MEMBER_VALIDATION_CONFIG = {
  age: {
    expectedMax: 75, // Mostrar advertencia si se supera
    absoluteMax: 110, // Rechazar si se supera
    min: 0 // Límite inferior (generalmente 0)
  }
};

export default MEMBER_VALIDATION_CONFIG;
